import {
  Component, OnInit, Output, EventEmitter 
} from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {
  activation_labels,
  tooltip_delay,
  regex,
} from '../../utils/constants.helper';
import { SetPasswordService } from '../../services/set-password.service';

@Component({
  selector: 'app-set-password',
  templateUrl: './set-password.component.html',
  styleUrls: ['./set-password.component.scss'],
})
export class SetPasswordComponent implements OnInit {
  @Output() passwordUpdateClick = new EventEmitter();

  protected readonly labels = activation_labels.memberUpdate;

  protected readonly tooltipDelay = tooltip_delay;

  formError: boolean = false;

  formMessage!: string;

  loading: boolean = false;

  memberPasswordForm!: FormGroup;

  constructor(private passwordService: SetPasswordService) {}

  ngOnInit(): void {
    this.memberPasswordForm = new FormGroup({
      password: new FormControl(null, [
        Validators.required,
        Validators.pattern(regex.PASSWORD_REGEX),
      ]),
      confirmPassword: new FormControl(null, [
        Validators.required,
        Validators.pattern(regex.PASSWORD_REGEX),
      ]),
    });
  }

  showErrorMessage() {
    const passwordField = this.memberPasswordForm.get('password');
    if (!passwordField?.valid) {
      passwordField?.markAsTouched();
    }
  }

  validateForm() {
    const password = this.memberPasswordForm.get('password')?.value;
    const confirmPassword = this.memberPasswordForm.get('confirmPassword')?.value;
    if (this.memberPasswordForm.valid && password === confirmPassword) {
      return true;
    }
    return undefined;
  }

  updatePassword(): void {
    const passwordRequest = {
      password: this.memberPasswordForm.get('password')?.value,
    };
    this.passwordService.updatePassword(passwordRequest).subscribe(
      (details) => {
        this.passwordUpdateClick.emit();
      },
      (error) => {
        this.formError = true;
        this.formMessage = error;
      }
    );
  }
}
